import React, { Component } from 'react'
import {
  map
} from 'lodash'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

import Button from '../button'

class ButtonGroup extends Component {
  ALLOWED_MODIFIERS = ['fill', 'unjoined']

  componentClassNames = () => {
    return bemClasses('button-group', this.ALLOWED_MODIFIERS, this.props)
  }

  renderButton = (buttonProps) => {
    return (
      <Button
        key={Math.random()}
        {...buttonProps}
        fullWidth={this.props.fill}
        onClickObject={this.props.onClickObject}
        hidden={this.props.hidden}
        visible={this.props.visible}
      />
    )
  }

  render = () => {
    if (this.props.buttons.length === 1) {
      return this.renderButton(this.props.buttons[0])
    }

    return (
      <div className={this.componentClassNames()}>
        { map(this.props.buttons, this.renderButton) }
      </div>
    )
  }
}

export default ButtonGroup
